<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="about" style="text-align: center">
    <img
      class="logo"
      src="@/assets/logo-dev-legacy.png"
      alt="Logo Devlegacy"
      title="Logo Devlegacy"
    />
    <article v-if="locale.locale === 'en'">
      <a-divider>About me</a-divider>
      <a-divider>Acknowledgment</a-divider>
    </article>
    <article v-if="locale.locale === 'es'">
      <a-divider>Acerca de mí</a-divider>
      <p>¡Hola! soy Dev.legacy().</p>
      <p>
        Desarrollador de software orientado a web utilizando tecnologías como
        PHP, MySQL y Node.js. Incursionado en el desarrollo front end y con
        experiencia en el back end.
        La resolución de problemas a través de algoritmia y todo lo nuevo que se puede aprender es parte de lo que me apasiona del mundo del desarrollo.
      </p>
      <a-divider>Agradecimientos</a-divider>
      <p>
        Este aplicación web ha sido desarrollada con la idea original y el apoyo
        de los siguientes cursos y plataformas:
      </p>
    </article>
    <a-list item-layout="vertical" size="large" :data-source="listData">
      <a-list-item slot="renderItem" key="index" slot-scope="item, index">
        <a-card
          style="background: #354658; width: 100%"
          slot="extra"
          size="small"
          hoverable
        >
          <Container slot="cover">
            <img
              class="img-fluid"
              alt="logo"
              :src="require(`@/assets/${item.logo}`)"
            />
          </Container>
        </a-card>
        <a-list-item-meta>
          <a
            target="_blank"
            rel="noopener noreferrer"
            slot="title"
            :href="item.url"
          >
            <a-icon type="link" /> Plataforma: {{ item.platform }}
          </a>

          <div slot="description">
            <h3>Enlaces:</h3>
            <div v-for="(repository, i) in item.repositories" :key="i">
              <a
                target="_blank"
                rel="noopener noreferrer"
                :href="repository.url"
                :title="repository.name"
              >
                <a-icon type="link" />
                <a-tooltip placement="right">
                  <template slot="title">{{ repository.name }}</template>
                  {{ repository.name }}
                </a-tooltip>
              </a>
            </div>
            <p>
              Lista de cursos utilizados y recomendados -
              {{ item.courses.length }}
            </p>
          </div>
        </a-list-item-meta>
        <!-- {{ index }} -->

        <a-list
          :grid="{ gutter: 16, sm: 1, lg: 2, xxl: 3 }"
          :data-source="item.courses"
        >
          <a-list-item slot="renderItem" slot-scope="item, index">
            <a
              target="_blank"
              rel="noopener noreferrer"
              :href="item.url"
              :title="item.title"
            >
              <a-card hoverable>
                <img slot="cover" alt="example" :src="item.image" />
                <a-card-meta :title="item.title" description=""></a-card-meta>
              </a-card>
            </a>
          </a-list-item>
        </a-list>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
  props: {
    locale: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      listData: [
        {
          platform: 'Webtraining.Zone',
          url: 'https://webtraining.zone',
          logo: 'logo-webtraining.png',
          courses: [
            {
              title: 'Curso Profesional de Vue.js',
              url: 'https://webtraining.zone/cursos/curso-profesional-vue-js',
              image:
                'https://webtraining.zone/img/metadata-courses/curso-profesional-vue-2018.jpg',
            },
          ],
          socialMedia: [
            {
              name: 'Facebook',
              username: 'webtrainingzone',
              origin: 'https://www.facebook.com',
              icon: {
                fontAwesome: 'fab fa-facebook',
              },
            },
            {
              name: 'Twitter',
              username: 'webtrainingzone',
              origin: 'https://twitter.com',
              icon: {
                fontAwesome: 'fab fa-twitter',
              },
            },
            {
              name: 'YouTube',
              username: 'AlexArriaga',
              origin: 'https://www.youtube.com',
              icon: {
                fontAwesome: 'fab fa-youtube',
              },
            },
          ],
          repositories: [
            {
              name: 'GitHub',
              url: 'https://github.com/webtraining-zone',
            },
            {
              name: 'GitHub',
              url: 'https://github.com/webtrainingmx',
            },
            {
              name: 'Facebook',
              url: 'https://www.facebook.com/webtrainingzone',
            },
            {
              name: 'Twitter',
              url: 'https://twitter.com/webtrainingzone',
            },
            {
              name: 'YouTube',
              url: 'https://www.youtube.com/AlexArriaga',
            },
          ],
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.logo {
  display: block;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px,
    rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  width: 260px;
  border-radius: 50%;
  margin: 20px auto;
}
</style>
